import {Component, Input} from '@angular/core';
import {MIN_DATE} from '../../../../../../../../../../constants/dateConstants';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'shared-szczegoly-lokalizacji',
  templateUrl: './szczegoly-lokalizacji.component.html'
})

export class SzczegolyLokalizacjiComponent {

  language = window.navigator.language

  get SZEROKOSC() { return this.formularzLokalizacjiUszkodzenia.controls.szerokosc }
  get DLUGOSC() { return this.formularzLokalizacjiUszkodzenia.controls.dlugosc }
  get WYSOKOSC() { return this.formularzLokalizacjiUszkodzenia.controls.wysokosc }
  get LICZBA_PIETER() { return this.formularzLokalizacjiUszkodzenia.controls.liczbaPieter }

  @Input()
  minimalnyRokRemontu = new Date(MIN_DATE);

  @Input()
  maksymalnyRokRemontu = new Date();

  @Input()
  pokazRokRemontu = false;

  @Input()
  pokazLiczbePieter = false;

  @Input()
  formularzLokalizacjiUszkodzenia!: UntypedFormGroup

  @Input()
  opisWspoldzielonychParametrow!: string;

  @Input()
  minimalnaLiczbaKondygnacji = 1;

  @Input()
  maksymalnaLiczbaKondygnacji = 10;

  @Input()
  pokazSzerokosc = false;

  @Input()
  pokazDlugosc = false;

  @Input()
  pokazWysokosc = false;

  @Input()
  minimalnyWymiar = 0.5;

  @Input()
  maksymalnyWymiar = 10;

  @Input()
  czyDataRemontuWymagana!: boolean

}
